import { isPlatformBrowser } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpRequest
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { WebsiteDialogeComponent } from 'libs/website/shared/src/lib/website-dialoge/website-dialoge.component';
import { NGXLogger } from 'ngx-logger';
import { LoaderServiceService } from '../loader-service.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public dialog: MatDialog,
    private logger: NGXLogger,
    public loaderService: LoaderServiceService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // const body = request.body;
    // const body = JSON.stringify(request.body);

    // const clone = request.clone({
    //   body
    // });

    let clone: HttpRequest<any>;
    let headers: HttpHeaders;

    // if the body is form data, we need to clone the request and set the content type to x-www-form-urlencoded
    if (request.body instanceof FormData) {
      headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });
      clone = request.clone({
        headers
      });
    } else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      clone = request.clone({
        headers
      });
    }

    // this.logger.debug(request);
    this.loaderService.show();
    return next
      .handle(clone)
      .pipe(finalize(() => this.loaderService.hide()))
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  handleError(error: HttpErrorResponse) {
    this.logger.error(error);
    if (isPlatformBrowser(this.platformId)) {
      if (!window.navigator.onLine) {
        this.dialog.open(WebsiteDialogeComponent, {
          data: { dialogType: 'no_internet_fail' }
        });
      } else if (error.status == 500) {
        this.dialog.open(WebsiteDialogeComponent, {
          data: { dialogType: 'internal_server_fail' }
        });
      }
      return throwError(error);
    }
    return throwError(error);
  }
}
